module.exports = __webpack_public_path__ + "static/ivoy-logo-2a88f38cced2903f597e703054f6424f.png";